import { errorCategories, errorToCodeException } from '../../../errors';
import { formatUserOperationGas, formatUserOperationRequest, getUserOperationError, } from 'viem/account-abstraction';
import { doubleGasIfLocalAnvil } from '../../../utils/anvilGasLimit';
import { isPaymasteredOp } from '../../../utils/isPaymasteredOp';
import { getStateOverrides } from '../utils/getStateOverrides';
export async function estimateGasLimit(args) {
    const { userOp, client, account, multiplier = 10 } = args;
    const request = userOp;
    try {
        if (isPaymasteredOp({
            entryPointVersion: account.entryPoint.version,
            paymasterAndData: request.paymasterAndData,
            paymasterData: request.paymasterData,
        })) {
            return request;
        }
        try {
            const params = [
                formatUserOperationRequest({
                    ...request,
                    ...(request.paymaster
                        ? {
                            paymasterPostOpGasLimit: 0n,
                            paymasterVerificationGasLimit: 0n,
                        }
                        : {}),
                    // Some Bundlers fail if nullish gas values are provided for gas estimation :') –
                    // so we will need to set a default zeroish value.
                    callGasLimit: 0n,
                    preVerificationGas: 0n,
                    verificationGasLimit: 0n,
                }),
                account?.entryPoint?.address,
            ];
            const result = await client.request({
                method: 'eth_estimateUserOperationGas',
                params: [
                    ...params,
                    getStateOverrides({
                        accountAddress: account.address,
                        chain: client.chain,
                    }),
                ],
            });
            return {
                ...formatUserOperationGas(result),
                callGasLimit: doubleGasIfLocalAnvil(client.chain?.id, formatUserOperationGas(result).callGasLimit),
                preVerificationGas: increaseByPercentage({
                    gas: formatUserOperationGas(result).preVerificationGas,
                    percentage: multiplier,
                }),
                verificationGasLimit: increaseByPercentage({
                    gas: formatUserOperationGas(result).verificationGasLimit,
                    percentage: multiplier,
                }),
            };
        }
        catch (error) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/only-throw-error
            throw getUserOperationError(error, {
                ...request,
            });
        }
    }
    catch (error) {
        const exception = errorToCodeException(error, errorCategories.userop_estimate_gas_failed);
        throw exception;
    }
}
export function increaseByPercentage({ gas, percentage }) {
    const value = gas;
    return value + (value * BigInt(percentage)) / 100n;
}
